import Vue from 'vue'
import Vuex from 'vuex'




import navigation   from './navigation.js'
import user         from './user.js'
import timeline     from './timeline.js'
import friends      from './friends.js'

Vue.use(Vuex)

export default new Vuex.Store({

  // strict: false -> don't activiate for production, cuz of performance
  strict: process.env.NODE_ENV !== 'production',
  
  modules: {
    navigation,
    user,
    timeline,
    friends
  },


  state: {
    todos: [
      { order: 100,
        status: 'Active',
        text: 'Verfügbarkeit von WeVent als App',
        infos: [
          'Umsetzung für Android und iOS'
        ]
      },
      { order: 300,
        status: 'Demnächst',
        text: 'Bearbeiten-Funktion für Events und Moments',
        infos: [
          'Funktion zum bearbeiten von Aktivitäten',
        ]
      },
      { order: 300,
        status: 'Demnächst',
        text: 'Info-Screen für Events und Moments',
        infos: [
          'Beim anklicken soll neuer Screen geöffnet werden',
          'Weitere Informationen ersichtlich',
        ]
      },
      
      { order: 400,
        status: 'Demnächst',
        text: 'Ausblenden von nicht gewünschten Content',
        infos: [
          'Ausblenden von einzelnen Events oder Moments',
          'Ausblenden von Usern',
        ]
      },
      { order: 500,
        status: 'Demnächst',
        text: 'Meldefunktion von unangemessenen Content',
        infos: [
          'Melde-Funktion für administrative Zwecke',
        ]
      },
      { order: 600,
        status: 'Demnächst',
        text: 'EventsByFriends',
        infos: [
          'Anzeigen, welche Events von Freunden favorisiert sind',
        ]
      },
      { order: 700,
        status: 'Demnächst',
        text: 'Moments und EventsByFriends umkreisbahängig anzeigen',
        infos: [
          'Auswahl-Option, ob Moments und EventsByFriends in Abhängigkeit des Umkreises angezeigt werden sollen oder nicht.',
        ]
      },
      { order: 800,
        status: 'Demnächst',
        text: 'Teilen - Funktion',
        infos: [
          'Share-Button zum teilen von Events',
        ]
      },
      { order: 900,
        status: 'Demnächst',
        text: 'Gruppen',
        infos: [
          'Gruppen für Moments',
          'Darüber kann gesteuert werden wer meine Moments sehen kann',
        ]
      },
      { order: 1000,
        status: 'Demnächst',
        text: 'Kommentare für Events und Moments auf Info-Screen',
        infos: [
          'Kommentarfunktion für User',
        ]
      },
      { order: 1100,
        status: 'Demnächst',
        text: 'Ersteller Informationen',
        infos: [
          'Anzeige für den Ersteller, wer an Moments oder Events teilnimmt',
        ]
      },
     
    ],
    version: {
      actual: 'v1.0.5 beta',
      versions: [
        { 
          version: '1.0.5',
          status: 'beta',
          date: '2019-06-07',
          text: 'Für den erstbesuch bei WeVent wurde ein Tutorial erstellt und die Wissbegierigen finden nun einen ToDo Liste im Settings-Bereich.',
          fixes: [
            'ToDo Liste erstellt',
            'Tutorial erstellt',
          ]
        },
        { 
          version: '1.0.4',
          status: 'beta',
          date: '2019-06-05',
          text: 'Timepicker, zum erstellen von Events und Moments, wurde überarbeitet und sollte nun auf allen Geräten funktionieren. Zusätzlich wurde der Add-Screen leicht überarbeitet um "Mobile" mehr Content zu sehen. Desweiteren wurden Verbesserung in der Login-Logik implementiert.',
          fixes: [
            'Timepicker ausgetauscht',
            'Add-Screen verbessert',
            'Login-Logik überarbeitet',
            'Verifizierungs-Information überarbeitet',
          ]
        },
        { 
          version: '1.0.3',
          status: 'beta',
          date: '2019-06-04',
          text: 'Kleinere Anpassungen und Information über noch nicht verfügbare Optionen wurden hinzugefügt.',
          fixes: [
            'Opening Event wurde zu Opening Moment',
            'Demnächst verfügbare Optionen wurden gekennzeichnet',
            'Header Image Events wurden angepasst',
            'Login wurde überarbeitet',
            'Menü Optionen hinzugefügt'
          ]
        },
        { 
          version: '1.0.2',
          status: 'beta',
          date: '2019-06-04',
          text: 'Hier kommt sogleich die nächste Nachbesserung ;) Im Login Bereich wurde eine kleine Beschreibung hinzugefügt und das hinzufügen von Moments oder Events wurde überarbeitet. Zudem ist es nicht mehr Pflicht ein Event-Bild auszuwählen.',
          fixes: [
            'Versionsverlauf hinzugefügt',
            'Add-Screen überarbeitet',
            '"Was ist Wevent?" hinzugefügt',
            'Automatische Eventbilder hinzugefügt'
          ]
        },
        { 
          version: '1.0.1',
          status: 'beta',
          date: '2019-06-03',
          text: 'Das erste Update mit kleiner Fehlerbehebung folgt zugleich',
          fixes: [
            'Login optimiert',
            'Verifizierungsmail angepasst',
            'RSS Feed optimiert'
          ]
        },
        {
          version: '1.0.0',
          status: 'beta',
          date: '2019-06-03',
          text: 'Start der Testphase von WeVent',
          fixes: [
            'Start',
            'Prototyp',
            'Testphase'
          ]
        },
       
      ]
    },
    loading: null,
    loadingEvents: null,
    loadingFavEvents: null,
    loadingMoments: null,
    loadingFavMoments: null,
    refreshLoading: null,

    error: null,
    success: null,

    breakPointMobile: 960,
    isMobile: '',
    lazyImg: require('@/assets/thumbnail_wevent.png'),
    brand: 'TextWeVent_thumbnail_beta.svg',
    // brand: 'Wevent_Logo_only_text_black.svg',
    

    searchActive: false,

    
    displayNews: false,


    view_profile: {
      selectedProfileComp: 'app-profile-display',
      profile_settingsdrawer: false
    },




    categories: {
      Music:        { title: 'Music',        color: 'red darken-1',         hex: '#E53935', colrgba: 'rgba(229,57,53,0.4)',   colrgbaback: 'rgba(229,57,53,0.05)', icon: 'fas fa-music', order: 1, orderCreate: 1 },
      Business:     { title: 'Business',     color: 'blue-grey lighten-3',  hex: '#B0BEC5', colrgba: 'rgba(176,190,197,0.4)', colrgbaback: 'rgba(176,190,197,0.05)', icon: 'fas fa-briefcase', order: 8, orderCreate: 2 },
      Party:        { title: 'Party',        color: 'pink',                 hex: '#E91E63', colrgba: 'rgba(233,30,99,0.6)',   colrgbaback: 'rgba(233,30,99,0.05)', icon: 'fas fa-cocktail', order: 2, orderCreate: 3 },
      Messe:        { title: 'Messe',        color: 'blue-grey darken-1',   hex: '#546E7A', colrgba: 'rgba(84,110,122,0.4)',  colrgbaback: 'rgba(84,110,122,0.05)', icon: 'far fa-registered', order: 8, orderCreate: 4 },
      MeetUp:       { title: 'MeetUp',       color: 'deep-orange accent-2', hex: '#FF6E40', colrgba: 'rgba(255,110,64,0.4)',  colrgbaback: 'rgba(255,110,64,0.05)', icon: 'fas fa-users', order: 3, orderCreate: 5 },
      Culture:      { title: 'Culture',      color: 'cyan darken-1',        hex: '#00ACC1', colrgba: 'rgba(0,172,193,0.4)',   colrgbaback: 'rgba(0,172,193,0.05)', icon: 'fas fa-university', order: 9, orderCreate: 6 },
      Wellness:     { title: 'Wellness',     color: 'amber',                hex: '#FFC107', colrgba: 'rgba(255,193,7,0.4)',   colrgbaback: 'rgba(255,193,7,0.05)', icon: 'fas fa-island-tropical', order: 4, orderCreate: 7 },
      Wissen:       { title: 'Wissen',       color: 'light-blue lighten-3', hex: '#81D4FA', colrgba: 'rgba(129,212,250,0.4)', colrgbaback: 'rgba(129,212,250,0.05)', icon: 'fas fa-book-reader', order: 10, orderCreate: 8 },
      Fun:          { title: 'Fun',          color: 'yellow darken-1',      hex: '#FDD835', colrgba: 'rgba(253,216,53,0.4)',   colrgbaback: 'rgba(253,216,53,0.05)', icon: 'fas fa-smile-beam', order: 5, orderCreate: 9 },
      Sport:        { title: 'Sport',        color: 'blue',                 hex: '#2196F3', colrgba: 'rgba(33,150,243,0.4)',  colrgbaback: 'rgba(33,150,243,0.05)', icon: 'fas fa-basketball-ball', order: 11, orderCreate: 10 },
      Market:       { title: 'Market',       color: 'green lighten-1',      hex: '#66BB6A', colrgba: 'rgba(102,187,106,0.4)', colrgbaback: 'rgba(102,187,106,0.05)', icon: 'fas fa-store', order: 6, orderCreate: 11 },
      Essen:        { title: 'Essen',  color: 'indigo darken-1',      hex: '#3949AB', colrgba: 'rgba(57,73,171,0.4)',   colrgbaback: 'rgba(57,73,171,0.05)', icon: 'fas fa-utensils', order: 12, orderCreate: 12 },
      Outdoor:      { title: 'Outdoor',      color: 'green darken-3',       hex: '#2E7D32', colrgba: 'rgba(46,125,50,0.4)',   colrgbaback: 'rgba(46,125,50,0.05)', icon: 'fas fa-hiking', order: 7, orderCreate: 13 },
      Family:       { title: 'Family',       color: 'purple darken-1',      hex: '#5E35B1', colrgba: 'rgba(94,53,177,0.4)',   colrgbaback: 'rgba(94,53,177,0.05)', icon: 'fas fa-child', order: 13, orderCreate: 14 },
      
    },

  },








  getters: {
    locale () {
      return navigator.language || navigator.userLanguage
    },
    path (state) {
      return state.route.path
    },
    error (state) {
      return state.error
    },
    success (state) {
      return state.success
    },
    loading (state) {
      return state.loading
    },
    refreshLoading (state) {
      return state.refreshLoading
    },
    loadingEvents (state) {
      return state.loadingEvents
    },
    loadingMoments (state) {
      return state.loadingMoments

    },
    
    
  },





  
  mutations: {
    restoreVuexStore(state) {
      state.user.user = null
      state.user.isNotVerified = null
      state.user.currentUserFireBaseEmail = null
      state.user.myFriends = []
      state.user.favEvents = []
      state.user.favMoments = []
      state.user.notifications = []


      state.timeline.loadedEvents = []
      state.timeline.loadedFavEvents = []
      state.timeline.loadedMoments = []
      state.timeline.loadedFavMoments = []
      state.timeline.filteredPosts = []
      // state.timeline.timelineFilter = {}
      // state.timeline.timelineResetFilter = {}
      // state.timeline.timelineStandardFilter = {}

      state.friends.foundFriends = []
    },

    setLoading (state, payload) {
      state.loading = payload
    },
    setDisplayNews (state) {
      state.displayNews = !state.displayNews
    },
    setLoadingEvents (state, payload) {
      state.loadingEvents = payload
    },
    setLoadingMoments (state, payload) {
      state.loadingMoments = payload
    },
    setLoadingFavEvents (state, payload) {
      state.loadingFavEvents = payload
    },
    setLoadingFavMoments (state, payload) {
      state.loadingFavMoments = payload
    },
    setRefreshLoading (state, payload) {
      state.refreshLoading = payload
    },
    setError (state, payload) {
      state.error = payload
    },
    setSuccess (state, payload) {
      state.success = payload
    },
    clearError (state) {
      state.error = null
    },
    clearSuccess (state) {
      state.success = null
    },

    
    

  
    setSelectedProfileComp: (state, payload) => {
      state.view_profile.selectedProfileComp = payload
      state.view_profile.profile_settingsdrawer = false
    },

    setIsMobile: (state, isMobile) => {
      state.isMobile = isMobile
    },

    searchActivated: (state) => {
      state.searchActive = !state.searchActive
    },
    deactivateSearch: (state, payload) => {
      state.searchActive = payload
    },
    click_profile_settingsdrawer: (state, val) => {
      state.view_profile.profile_settingsdrawer = val
    },
  },








  actions: {
    
    clearError ({commit}) {
      commit('clearError')
    },
    clearSuccess ({commit}) {
      commit('clearSuccess')
    },
  }


})
